import { render } from "./ChatDocument.vue?vue&type=template&id=4a62e9cc"
import script from "./ChatDocument.vue?vue&type=script&lang=js"
export * from "./ChatDocument.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__